<template>
  <div style="text-align: justify">
    <a-row :gutter="[12, 24]">
      <a-col
        :xs="{ span: 22, offset: 1 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 22, offset: 1 }"
        :xl="{ span: 22, offset: 1 }"
        :lg="{ span: 22, offset: 1 }"
      >
        <span style="font-size: 40px; font-weight: bolder; color: black">
          Feedback and Help</span
        >
        <a-alert type="success" show-icon>
          <div slot="message" style="text-align: justify">
            <span style="line-height: 30px; font-size: 20px">
              We appreciate your feedback, ideas, and suggestions. Our aim is to
              enhance both the functionality and user experience of PerturbDB.
              Your input is vital and will guide our efforts to improve our
              services. To provide your feedback and comments, please click the
              link to access the form on
              <a
                href="https://docs.qq.com/sheet/DU0xHZlVWYWNGdkht?tab=BB08J2"
                target="_blank"
                style="color: blue"
                >Tencent Documentation</a
              >.</span
            >
            <div style="margin-top: 5px; text-align: center">
              <img
                onmouseover="this.style.cursor='pointer'"
                @click="
                  goToFeed(
                    'https://docs.qq.com/sheet/DU0xHZlVWYWNGdkht?tab=BB08J2'
                  )
                "
                src="http://research.gzsys.org.cn/perturbdb/image/sheet.png"
                style="width: 100%; width: 50%"
              />
            </div>
          </div>
        </a-alert>
      </a-col>

      <a-col
        :xs="{ span: 22, offset: 1 }"
        :sm="{ span: 22, offset: 1 }"
        :md="{ span: 22, offset: 1 }"
        :xl="{ span: 22, offset: 1 }"
        :lg="{ span: 22, offset: 1 }"
        style="margin-top: -15px"
      >
        <div class="card-container" style="text-align: justify">
          <a-tabs default-active-key="1" size="small" :tabBarGutter="-2">
            <a-tab-pane key="1">
              <span slot="tab" style="font-size: 20px">
                <a-icon type="home" />
                Home
              </span>
              <div style="background-color: white; padding: 20px 20px">
                <span style="font-size: 20px; font-weight: bolder"
                  >1. Browse by gene</span
                >
                <br />

                <span style="font-size: 16px"
                  >The PerturbDB homepage features an intuitive search box that
                  enables users to swiftly navigate and explore genes within the
                  database. Upon selecting a gene, users are automatically
                  directed to a detailed search results page.
                </span>
                <div style="text-align: center; margin-top: 10px">
                  <img
                    width="60%"
                    height="60%"
                    src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/01search_shouye.png"
                  />
                </div>
                <a-divider dashed style="color: black"></a-divider>

                <span style="font-size: 20px; font-weight: bolder"
                  >2. Rapidly search for the
                  <span style="color: blue">SIRT7</span> gene</span
                >
                <br />
                <ul>
                  <li>
                    <span style="font-size: 16px"
                      >A. The quick search results page displays a detailed
                      listing of the gene's appearances in Perturb-Seq and Bulk
                      perturbation RNA-Seq datasets. Click on the first column
                      for swift access to a comprehensive analysis page, which
                      elaborates on the effects of perturbation on the gene.
                    </span>
                    <div style="text-align: center; margin-top: 10px">
                      <img
                        width="61%"
                        height="60%"
                        src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/home2.png"
                      />
                    </div>
                  </li>
                  <li>
                    <span style="font-size: 16px"
                      >B. To enhance the identification of gene abnormalities
                      across multiple cancer types, we have introduced a
                      pan-cancer differential gene analysis module.</span
                    >
                    <div style="text-align: center; margin-top: 10px">
                      <img
                        width="61%"
                        height="60%"
                        src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/home3.png"
                      />
                    </div>
                    <span style="font-size: 16px">
                      Clicking the magnifying glass icon allows users to easily
                      generate and download box plots customized to specific
                      dimensions.</span
                    >
                    <div style="text-align: center; margin-top: 10px">
                      <img
                        width="61%"
                        height="60%"
                        src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/home4.png"
                      />
                    </div>
                  </li>
                  <li>
                    <span style="font-size: 16px"
                      >C. PerturbDB have enhanced the quick search results page
                      by incorporating drug-gene prediction results, sorting
                      drugs by the number of intersections across datasets in
                      descending order. We advise users to meticulously select
                      top-ranked drugs for experimental validation. Furthermore,
                      clicking on the first column provides access to a detailed
                      information page for the selected drug.</span
                    >
                    <div style="text-align: center; margin-top: 10px">
                      <img
                        width="61%"
                        height="60%"
                        src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/home5.png"
                      />
                    </div>
                  </li>
                </ul>

                <!-- <span style="font-size: 16px"
                  >PerturbDB has developed four major functional modules:
                  <a-tag color="#f50"> Perturb-seq </a-tag>,
                  <a-tag color="#2db7f5"> Perturbation clusters</a-tag>,
                  <a-tag color="#87d068"> Inhibitors </a-tag>and
                  <a-tag color="#108ee9"> PGSEA </a-tag>. Users can conveniently
                  navigate to each module page by clicking on the respective
                  images.</span
                >
                <div style="text-align: center; margin-top: 10px">
                  <img
                    width="61%"
                    height="60%"
                    src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/02module_shouye.png"
                  />
                </div> -->
                <a-divider dashed style="color: black"></a-divider>

                <span style="font-size: 20px; font-weight: bolder"
                  >3. About project</span
                >
                <br />

                <span style="font-size: 16px">
                  This section features updates from PerturbDB, contact
                  information for inquiries, and visitor records.</span
                >
                <div style="text-align: center; margin-top: 10px">
                  <img
                    width="61%"
                    height="60%"
                    src="http://research.gzsys.org.cn/perturbdb/image/helpDocument/03about_shouye.png"
                  />
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane key="2">
              <span slot="tab" style="font-size: 18px">
                <a-icon type="gene" />
                1. Gene
              </span>
              <genehelp />
            </a-tab-pane>
            <a-tab-pane key="3">
              <span slot="tab" style="font-size: 18px">
                <a-icon type="gene" />
                2. Dataset
              </span>
              <datasethelp />
            </a-tab-pane>
            <a-tab-pane key="4">
              <span slot="tab" style="font-size: 18px">
                <a-icon type="gene" />
                3. Perturbation cluster
              </span>
              <clusterhelp />
            </a-tab-pane>
            <a-tab-pane key="5">
              <span slot="tab" style="font-size: 18px">
                <a-icon type="gene" />
                4. Inhibitor
              </span>
              <cancerHallmark />
            </a-tab-pane>
            <a-tab-pane key="7">
              <span slot="tab" style="font-size: 18px">
                <a-icon type="gene" />
                5. Cancer
              </span>
              <cancer />
            </a-tab-pane>
            <a-tab-pane key="6">
              <span slot="tab" style="font-size: 18px">
                <a-icon type="gene" />
                6. Tools
              </span>
              <gpeahelp />
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import genehelp from "./help/geneHelp.vue";
import datasethelp from "./help/datasetHelp.vue";
import clusterhelp from "./help/clusterHelp.vue";
import cancerHallmark from "./help/cancerHallmark.vue";
import gpeahelp from "./help/gpeaHelp.vue";
import cancer from "./help/cancerHelp.vue";

export default {
  components: {
    genehelp,
    datasethelp,
    clusterhelp,
    cancerHallmark,
    gpeahelp,
    cancer,
  },
  methods: {
    goto(value) {
      this.$message.success(value);
    },
    goToFeed(value) {
      let href = value;
      window.open(href, "_blank");
    },
  },
  data() {
    return {
      website: "http://research.gzsys.org.cn/perturbdb",
      formLayout: "horizontal",
      customStyle:
        "background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden;font-size:25px;line-height:25px",
    };
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}

.card-container {
  background: #f5f5f5;
  overflow: hidden;
  padding: 10px;
}
</style>
